
<div class="h-100 w-100">
    <c-site-contract-flip-card
        v-if      = "contractValid"
        :title    = "$t('contract.mnt.title')"
        :contract = "contract"
        :edit     = "true"
        :unit     = "unit"
        @readonly = "onReadonly"
        @store    = "onStore"
    >
        <template v-slot:front>
            <c-contract-mnt-terms
                :contract  = "contract"
                :readonly  = "readonly"
                :unit-mode = "true"
                class      = "mt-3"
            />
            <v-row class="no-frame pt-6">
                <f-read-only-field
                    class  = "w-100 ro-gap"
                    :label = "$t('contract.mnt.service')"
                    :value = "service"
                    filled
                />
            </v-row>
            <v-row class="no-frame">
                <f-read-only-field
                    class  = "w-100 ro-gap"
                    :label = "$t('contract.mnt.prmanager')"
                    :value = "manager"
                    filled
                />
            </v-row>

        </template>
    </c-site-contract-flip-card>

    <div
        v-if  = "!contractValid"
        class = "w-100 h-100"
    >
        <c-column-header
            label = "Wartung (kein Vertrag)"
            class  = "primary mb-1 w-100"
        />
        <div class  = "lm-border mb-1 w-100" style="height: calc(100% - 29px)">

        </div>
    </div>
</div>
